import { render } from "./BasicTable.vue?vue&type=template&id=488781e2"
import script from "./BasicTable.vue?vue&type=script&lang=ts"
export * from "./BasicTable.vue?vue&type=script&lang=ts"
script.render = render

export default script